import { Table, TableColumn } from '@sixfold/common-ui';
import React from 'react';

import { indexValueToPercentage } from '../../lib/util/string';
import { VisibilityIssue } from '../entities';

export interface Props {
  visibilityIssues: VisibilityIssue[] | null;
  mainVisibilityIssue: VisibilityIssue | null;
}

type IssueRow = {
  id: React.Key;
  type: string;
  index: number;
};

const columns: TableColumn<IssueRow>[] = [
  { id: 'type', title: 'Issue type' },
  {
    id: 'index',
    title: 'Issue index',
    cellContent: ({ row }) => indexValueToPercentage(row.index),
  },
];

export const TourVisibilityIssueList: React.FunctionComponent<Props> = ({ visibilityIssues, mainVisibilityIssue }) => {
  const issues = (visibilityIssues ?? []).filter((issue) => issue.index > 0);
  const data: IssueRow[] = issues.map((issue, idx) => ({
    id: idx,
    type: issue.type,
    index: issue.index,
  }));

  return (
    <>
      <h3>Visibility issues</h3>

      {mainVisibilityIssue !== null && (
        <p>
          Main visibility issue: <strong>{mainVisibilityIssue.type}</strong>
        </p>
      )}
      {data.length === 0 ? (
        <p>No visibility issues</p>
      ) : (
        <Table data={data} columns={columns} className="compact-table" />
      )}
    </>
  );
};
